<template>
  <div>
    <img :src="imageSrc" class="handclap hand-1" />
    <img :src="imageSrc" class="handclap hand-2" />
    <img :src="imageSrc" class="handclap hand-3" />
    <img :src="imageSrc" class="handclap hand-4" />
    <img :src="imageSrc" class="handclap hand-5" />
    <img :src="imageSrc" class="handclap hand-6" />
    <img :src="imageSrc" class="handclap hand-7" />
    <img :src="imageSrc" class="handclap hand-8" />
    <img :src="imageSrc" class="handclap hand-9" />
    <img :src="imageSrc" class="handclap hand-10" />
    <audio
      v-show="false"
      :src="audioSrc"
      controls
      preload="auto"
      ref="audio-effect"
    />
  </div>
</template>
<script>
import Util from '@/util'
import imageSrc from '@/assets/images/effects-menu/hand-clap.gif'
import audioSrc from '@/assets/audio/hand-clapping.mp3'

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      imageSrc,
      audioSrc,
    }
  },
  created() {
    this.preLoadAsset()
  },
  mounted() {
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    audioEffect.play().catch(() => {})
    audioEffect.addEventListener('play', () => {
      this.animatedHandClap()
    })
    audioEffect.addEventListener('ended', () => {
      this.close()
    })
  },
  destroyed() {
    const audioEffect = this.$refs['audio-effect']
    if (!audioEffect) return
    audioEffect.pause()
  },
  methods: {
    animatedHandClap() {
      const hands = document.getElementsByClassName('handclap')
      for (let i = 0; i < hands.length; i++) {
        const hand = hands.item(i)
        hand.style.position = 'absolute'
        hand.animate(
          {
            bottom: ['1500px'],
          },
          {
            duration: 12000,
            easing: 'ease-in-out',
            iterations: 1,
          },
        )
      }
    },
    preLoadAsset() {
      Util.preloadImage({ url: imageSrc })
    },
  },
}
</script>
<style scoped lang='scss'>
.hand-1 {
  bottom: 8rem;
}
.handclap {
  position: absolute;
  width: 5rem;
  & +.hand-2 {
    left: 10rem;
    bottom: -4rem;
  }
  & +.hand-3 {
    right: 10rem;
    bottom: -6rem;
  }
  & +.hand-4 {
    left: 2rem;
    bottom: 3rem;
  }
  & +.hand-5 {
    left: 25rem;
    bottom: 2rem;
  }
  & +.hand-6 {
    right: 18rem;
    bottom: 14rem;
  }
  & +.hand-7 {
    right: 26rem;
    bottom: 2rem;
  }
  & +.hand-8 {
    left: 34rem;
    bottom: -5rem;
  }
  & +.hand-9 {
    right: 2rem;
    bottom: 6rem;
  }
  & +.hand-10 {
    left: 15rem;
    bottom: 10rem;
  }
}
</style>
